import { fetchWithAuth } from '@/lib/fetchWithAuth';
import type {
  CatalogoOrcamento,
  OrcamentoCarregador,
  OrcamentoCarregadorResumo,
} from '@/types/orcamentosCarregadores';

const BASE = '/api/orcamentos-carregadores';

export class OrcamentoApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'OrcamentoApiError';
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetchWithAuth(`${BASE}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new OrcamentoApiError(data?.error || `Erro ${res.status}`);
  }
  return data as T;
}

const json = (body: unknown) => JSON.stringify(body);

export const orcamentosCarregadoresApi = {
  catalogo: () => request<CatalogoOrcamento>('/catalogo'),
  listar: () => request<OrcamentoCarregadorResumo[]>('/'),
  obter: (id: string) => request<OrcamentoCarregador>(`/${id}`),
  criar: (orcamento: Partial<OrcamentoCarregador>) =>
    request<OrcamentoCarregador>('/', { method: 'POST', body: json(orcamento) }),
  salvar: (id: string, orcamento: Partial<OrcamentoCarregador>) =>
    request<OrcamentoCarregador>(`/${id}`, { method: 'PUT', body: json(orcamento) }),
  excluir: (id: string) => request<{ ok: true }>(`/${id}`, { method: 'DELETE' }),
  baixarPdf: async (id: string) => {
    const res = await fetchWithAuth(`${BASE}/${id}/pdf`, { timeoutMs: 120_000 });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new OrcamentoApiError(data?.error || `Erro ${res.status}`);
    }
    return res.blob();
  },
};

export const formatarMoedaOrcamento = (valor: number | null | undefined) =>
  (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
